import { WaitlistForm } from "./WaitlistForm";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1632260260864-caf7fde5ec36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxhbWJlciUyMHNwYXJrcyUyMHRlY2hub2xvZ3klMjBhYnN0cmFjdHxlbnwwfHx8fDE3OTIwNjkyNjB8MA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <header
      data-testid="hero-section"
      className="max-w-6xl mx-auto px-6 pt-20 pb-24 border-b border-seam"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-ember/10 border border-ember/30 text-ember text-xs font-semibold rounded-full mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-ember" />
            <span>Zero Token Incineration</span>
          </div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-normal leading-[1.02] text-white tracking-tight mb-6">
            <span className="flint-line">
              <span>Cut AI coding</span>
            </span>
            <span className="flint-line">
              <span>agent token costs</span>
            </span>
          </h1>
          <p className="flint-fade flint-fade-sub text-lg text-smoke leading-relaxed max-w-xl mb-8">
            Keep your preferred coding agent. Flintly adds recoverable context
            compression to slash token burn without losing context.
          </p>

          <div id="waitlist" className="flint-fade flint-fade-rail max-w-md">
            <WaitlistForm variant="hero" />
            <p className="text-xs text-smoke mt-2">
              Local proxy, zero cloud dependency, no account required.
            </p>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative rounded-2xl border border-seam bg-coal p-4 shadow-xl">
            <div className="relative aspect-[4/5] rounded-xl overflow-hidden border border-seam">
              <img
                src={HERO_IMAGE}
                alt="Luminous amber sparks condensing large code trees into lean context blocks"
                data-testid="hero-image"
                className="flint-drift absolute inset-0 w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-ground/70 via-transparent to-ground/80" />
              <div className="absolute inset-0 p-6 flex flex-col justify-between text-xs text-smoke">
                <div className="flex justify-between items-center border-b border-seam/80 pb-2">
                  <span className="text-ember font-semibold">
                    flintly-daemon
                  </span>
                  <span className="text-[11px] font-mono">127.0.0.1:8120</span>
                </div>
                <div className="bg-black/50 backdrop-blur-sm p-4 rounded border border-seam my-auto space-y-1.5 font-mono text-xs text-white">
                  <div className="text-smoke">Agent Session: Cursor</div>
                  <div className="text-ember">Input Tree: 184,200 tokens</div>
                  <div className="text-green-400">
                    Compressed: 22,400 tokens
                  </div>
                  <div className="text-smoke">Lossless Recall: Verified</div>
                </div>
                <div className="flex justify-between text-[11px] text-smoke">
                  <span>Pipeline Status</span>
                  <span className="text-green-400">Ready</span>
                </div>
              </div>
            </div>
            <div className="mt-3 flex justify-between text-xs text-smoke">
              <span>Lossless AST Pruning</span>
              <span>Local Proxy</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
